const data = [
    {
        id: 1,
        name: "Курс первый",
        lessons: [
            {
                id: 1,
                name: "Введение / Знаки зодиака / Стихии / Классификация",
                description: `Урок погружает в захватывающий мир астрологии, где освоим основные понятия: космограмма, натальная карта, планеты солнечной системы, эклиптика и знаки зодиака. Узнаете про стихии и их классификацию.
        Практика на примерах известных личностей: Ширвиндт М, Ургант И, Лоуренс Дж и Лановой В.`
            },
            {
                id: 2,
                name: "Оси в зодиаке. Деление космограммы на полусферы и квадранты.",
                description: `На уроке Вы узнаете, как знаки работают осями, делятся на полусферы и квадранты. Инь – янь (противоположности), полный цикл развития в 12 стадиях. Раскроем понятие темперамента по карте человек. 
Примеры по картам: Брэд Пит, А Джоли, Пушкин, Рузвельт, Черниговская.`
            },
            {
                id: 3,
                name: "Характеристика Солнца.",
                description: `Познакомитесь с астрологической характеристикой Солнца. Какую осознанность проявляет каждая личность? Узнаем какую роль проявляет планета в карте: внутреннее и внешнее, черты характера, в профессии.
Примеры на картах: С Саровский, Эрнест Дюшен, Джейсон Стетхем, Кристофер Нолан.`
            },
            {
                id: 4,
                name: "Солнце в знаках.",
                description: `Откроете природу каждого знака зодиака и как через планету Солнце рожденная личность проявляет себя в этом материальном мире. 
Примеры на картах: А Пугачева, М Прохоров, П Маккартни, М Джексон, А Овечкин, В Путин, Деми Мур, Ф Конюхов, С Королев, В Высоцкий, Ф Шопен.`
            },
            {
                id: 5,
                name: "Характеристика Луны. Луна в знаках.",
                description: `Окунаемся в мир знаний про Луну. Узнаем темы адаптации, питания и расслабления, проявление в характере, профессии. Какова лучшая реализация и профессии Луны. Почувствуем ее в 12 знаках зодиака.
Примеры: К Ивлев, Шон Пенн, П Маккартни, Е Примаков, Н Аллилуева, Е Касперский, Т Видинеева.`
            },
            {
                id: 6,
                name: "Характеристика Меркурия. Меркурий в знаках. ",
                description: `Познакомимся с планетой Меркурий. Каким мышлением, контактностью, работой с информацией обладает человек от рождения. Как помогает нам в работе с пространством, в определении профессии. 
Примеры: Петр 1, событие: несчастный случай), А Пугачева, А Штиглиц, Доктор Лиза, Н Вавилов.`
            },
            {
                id: 7,
                name: "Характеристика Венеры. Венера в знаках. ",
                description: `Погрузимся в мир чувств через планету Венера. Как показывает свои эмоциональные состояния личность интенсивно или сдержанно?  Лучшее для проявления  – отношения, партнерство.
Примеры: Е Дружинин и Мигель, Н Кидман, М Терехова, Татьяна Самойлова (актриса), В Баженов, Д Робертс, Вивиан Мэри Харти, А Джоли. `
            },
            {
                id: 8,
                name: "Характеристика Марса. Марс в знаках.",
                description: `Тут мы узнаем, как проявлены воля и действия рожденного при помощи планеты Марс. Решительность, смелость, мужество или неторопливость и с оглядкой на других людей.
Примеры: К Хабенский, Кончаловский, А Овечкин, Леонардо-да-Винчи, Л Яшин, И Тальков.`
            },
            {
                id: 9,
                name: "Характеристика Юпитера. Юпитер в знаках.",
                description: `Знания о планете Юпитер помогут понять движение к цели, успех и рост в социальном мире, самооценку и отношения с авторитетными людьми, самооценку – как взгляд на себя со стороны.
Примеры: Д Менделеев, Ф Шаляпин, А Тарковский, М Шолохов, А Пушкин, Ю Гагарин, М Левин, А Чехов, Леонардо-да-Винчи.`
            },
            {
                id: 10,
                name: "Характеристика Сатурна. Сатурн в знаках.",
                description: `Строгая планета Сатурн расскажет, как у личности с дисциплиной, насколько прочным он ощущает мир, как встроиться во внешние структуры, как относиться ко времени, что для него опора.
Примеры: Петр 1, М Ломоносов, В Ленин, П Пикассо, М Калашников, Б Ельцин, А Штиглиц, Ю Скуратов, В Маяковский, Д Певцов, А Пушкин, Шойгу.`
            },
            {
                id: 11,
                name: "Характеристика Урана. Уран в знаках",
                description: `Познакомимся с Ураном, который выводит человека за рамки привычного. Как в характере человека проявляются: стремление к свободе, независимости потребность к новому и переменам.
Примеры: А Экзюпери, В Высоцкий, С Королев, Т Черниговская, С Вронский, И Ньютон, П Чайковский.`
            },
            {
                id: 12,
                name: "Характеристика Нептуна. Нептун в знаках.",
                description: `Таинственный мир Нептуна, который дает чувство единения с миром и другими людьми. Главный мотив: желание достичь внутренней гармонии, религиозность. Отрицательное проявление: обман, зависимость.
Примеры: М Ломоносов, Эйзенштейн, Вронский, Рихард Зорге, Циолковский.`
            },
            {
                id: 13,
                name: "Характеристика Плутона. Плутон в знаках. ",
                description: `Властный мир Плутона, который дает события и ситуации неотвратимые. Дает власть над людьми, а также умение ими руководить и организовывать, подавляя их волю. 
Примеры:  В Третьяк, М Кюри, Касперский, М Мишустин, Наполеон 1, Далай Лама, Борис Ельцин.`
            },
        ],
    },
    {
        id: 2,
        name: "Курс второй",
        lessons: [
            {
                id: 1, //14
                name: "Достоинства планет на круге в 12 знаков зодиака",
                description: `Природа проявления планеты наиболее сильная в знаке ее владения – это энергия управления. О внутренних качествах планет: силе и слабости, дружбе и вражде, которые ярко видно в характере, в темпераменте личности.
Примеры: Л Толстой, Леонардо да Винчи, Билл Гейтс, Ф Конюхов, К Хабенский, Принцесс Диана, В Высоцкий, В Мессинг.`
            },
            {
                id: 2, //15
                name: "Общее понятие аспекта. Классификация - мажорные и минорные.",
                description: `Аспект создает явление резонанса между планетами, рождая новое качество характера. Мажорные проявлены более в событиях, минорные более в качестве состояний и проявлений личности.
Примеры: А Пушкин, В Жириновский, Аллилуева, Макаренко, К Маркс.`
            },
            {
                id: 3, //16
                name: "Виды аспектов - гармоничные и напряженные. Орбис аспекта.",
                description: `Планеты взаимодействуют и влияют на характер. В одних положениях эффективно, вместе, в одном направлении, а в других конфликтно, сталкивая мотивации внутри человека или события во круг него. 
Примеры: Н Мордюкова, М Матье, Жириновский, С Рябков.`
            },
            {
                id: 4, //17
                name: "Аспекты Солнца.",
                description: `Аспекты Солнца с другими планетами расскажут о том, с помощью каких инструментов индивидуальность проявляет себя. Темы раскроют каков стиль взаимодействия человека с внешней средой.
Примеры: Далай Лама, Андреа Меза, Гарри Стайлз, Джеми Мур, А Джоли, Б Питт, А Меркель, Джеки Чан, Е Евтушенко, Уитни Хьюстон и др.`
            },
            {
                id: 5, //18
                name: "Аспекты Меркурия.",
                description: `Аспекты Меркурия покажут об особенностях мышления человека, как работает с информацией, общается с другими людьми в повседневности. 
Примеры: А Эйнштейн, В Даль, с Шойгу, В Жириновский, Г Галилей и др.`
            },
            {
                id: 6, //19
                name: "Аспекты Луны.",
                description: `Аспекты Луны указывают о том, как человек взаимодействует с внешним миром: расслаблен или напряжен, отношения в семье и с мамой, его адаптивность, как устроен быт человека.
Примеры: И Маск, Сталин, Н Кидман, Аль Пачино, Петр 1, С Саровский, В Матвиенко, М Джексон, Зеленский, Е, Рерих Ельцин и другие.`
            },
            {
                id: 7, //20
                name: "Аспекты Венеры и Марса.",
                description: `Аспекты Венеры с планетами покажут об особенностях эмоциональности человека, интенсивности проявления его чувств и желаний. Аспекты Марса о том, как действует человек, о решительности.
Пример: К Циолковский, Е Рерих, А Кашпировский, Л Вайкуле, М Галкин, А Пугачева, С П Королев, И Сталин, Тур Хейердал, Л Толстой.`
            },
            {
                id: 8,
                name: "Аспекты социальных и высших планет.",
                description: `Аспекты Социальных и высших планет показывают социальную роль человека, каковы его цели, дисциплина, организованность и задачи поколения, в котором реализуется личность.
Примеры: Х Колумб, Наполеон 1, Роберт де Ниро, начало ВО войны, Тур Хейердал, Д Менделеев, Н Тесла, Жак Ив Кусто.`
            },
            {
                id: 9,
                name: "Ретроградность. Качество планет в момент ретроградности.",
                description: `Ретроградность – от слова обернуться, прошлое, старый. Тема такого положения планеты – это углубиться, испытывать в жизни более напряжения по данной теме, уделять больше внимания этим качествам, обновить опыт. 
Пример: Дэми Мур, м Джексон, А Меркель, Д Менделеев, Леонардо да Винчи, И Ньютон, В Даль, Х Колумб, Е Рерих.`
            },
            {
                id: 10,
                name: "Фигуры Джонса. Ключи к интерпретации гороскопа.",
                description: `Астролог Марк Джонс довел до нас фигуры, которые образовали в момент рождения конкретный рисунок. Рисунок фигуры позволяют сделать вывод о фундаментальном способе самовыражения индивида. 
Пример: Л Вайкуле, Дж Чан, Н Крупская, в Матвиенко, Ф Шопен, М Матье, В Ленин, И Маск, М Левин, Билл Гейтс, З Фрейд, Е Плющенко и др. `
            },
            {
                id: 11,
                name: "Формула Души. Цепочки диспозиций.",
                description: `Знания урока покажут, как планеты отдают энергию друг другу. Образуется цепочка диспозиторов по владению, которая отражает внутреннюю взаимосвязь мотивации в психике человека.
Примеры: В Матвиенко, Шанель, Л Толстой, И Роднина, В Терешкова и еще 14 карт известных личностей.`
            },
            {
                id: 12, //25
                name: "Лунные (кармические узлы). Лунные узлы осями в знаках.",
                description: `Вы узнаете, что означают кармические узлы в карте человека, от куда они берутся, какое проявление в знаках зодиака и домах происходит и как проявляется в жизни личности. 
Примеры: Мария Кюри, В Матвиенко, М Джексон, М Влади, А Пушкин, В Жириновский, В Высоцкий, Н Мордюкова, Х Колумб, С П Королев и другие. `
            },
            {
                id: 13,
                name: "Планеты в критических градусах. ",
                description: `Обучающийся познакомятся со спецификой первых и последних градусов зодиакальных знаков и с особенностями стоящих в них планет. Тема раскрывает по каким планетам у человека есть опыт, а где он новичок.
Примеры: на уроке задействовано 33 карты. `
            },
        ],
    },
    {
        id: 3,
        name: "Курс третий",
        lessons: [
            {
                id: 1,
                name: "Астрологические дома, квадранты, классификация домов.",
                description: `Наше путешествие по жизни состоит из множества видов деятельности и эмоций, работы, честолюбия, надежд, собственности и отношений. Астрология делит жизнь на сферы, а сферы получили наименования: Дома.
Примеры: Бил Гейтс, П Чайковский, Петр 1, А Тарковский, В Высоцкий, Д Менделеев, Б Уиллис и другие.`
            },
            {
                id: 2,
                name: "Астрологические дома – сферы деятельности 1 квадранта.",
                description: `Первый квадрант карты дает судьбу лидера, человек активно проявляет себя в жизни. Он идет путем показать, что я есть и что хочу делать, действовать. Включается личная воля человека.
Примеры: А Шварц негр, Е Плющенко, Е Рерих, Леонардо да Винчи, К Хабенский, Ю Лужков, Шумахер и другие.`
            },
            {
                id: 3,
                name: "Астрологические дома – сферы деятельности 2 квадранта.",
                description: `Дома (сферы) второго квадранта карты дают судьбу идущего путем личной ответственности за близких, семью, детей, игра и рабочий коллектив. Он в судьбе идет через чувства.
Примеры: Моцарт, М Левин, Д Менделеев, В Зеленский, А Тарковский, У Хьюстон и другие.`
            },
            {
                id: 4, //30
                name: "Астрологические дома – сферы деятельности 3 квадранта.",
                description: `Дома (сферы) третьего квадранта карты дают человеку выделиться в социуме. Он получают судьбу интенсивного взаимодействия во внешнем мире, мотивирован внешними достижениями. Идет через отношения.
Примеры: Мирей Матье, Ф Шопен, Наполеон 1, В Жириновский, В Маяковский, П Чайковский и другие.`
            },
            {
                id: 5,
                name: "Астрологические дома – сферы деятельности 4 квадранта.",
                description: `Дома (сферы) четвертого квадранта карты дают человеку судьбу социальной значимости, но в роли руководителя, наставника, мудреца. Это люди общества, но со статусом. Путь ответственности за других людей.
Пример: Аль Па Чино, К Хабенский, Р Рейган, Петр 1, Ю Лужков и др.`
            },
            {
                id: 6,
                name: "Управители 1 квадранта в 12 домах гороскопа. Проявление планет.",
                description: `Сила Планет управителей домов первого квадранта влияют на волю личности. Показывают физические, энергетические способности, поведение человека и его основной фон активности.
Примеры: Махатма Ганди, Д Менделеев, Б Гейтс, Ричард Гир, Далай Лама, В Высоцкий и др.  `
            },
            {
                id: 7,
                name: "Управители 2 квадранта в 12 домах гороскопа. Проявление планет.",
                description: `Планеты управители второго квадранта позволяют определить склонности человека к сотрудничеству с другим, его возможности к конкурентной деятельности, включение творческих импульсов.
Примеры: Дэми Мур, Паганини, А Абдулов,  Мирей Матье и др.`
            },
            {
                id: 8,
                name: "Управители 3 квадранта в 12 домах гороскопа. Проявление планет.",
                description: `Проявление третьего квадранта через планет управителей в данной зоне определяет способности человека воспринимать внешний мир. Это сферы межличностного общения, использования чужой воли, ресурсов и расширение сознания. 
Примеры: Р де Ниро, Б Пит, Т Хейердал, Бил и Мелинда Гейтс и др.`
            },
            {
                id: 9, //35
                name: "Управители 4 квадранта в 12 домах гороскопа. Проявление планет.",
                description: `Сила влияния на человека планет управителей четвертого квадранта проявлена: представлением об иерархии ценностей, умение организовать собственный потенциал и предвидеть результаты своих дел.
Примеры: Королева Елизавета II, В Жириновский, Л Брежнев, Н Цискаридзе, И Ургант и др.`
            },
            {
                id: 10,
                name: "Напряженные конфигурации аспектов.",
                description: `Любая конфликтная ситуация или трудная жизнь – это опыт. Конфигурации напряженные, значит планеты встали в сложные отношения и решать судьбоносные ситуации нужно через преодоления.
Примеры: М Левин, М Матье.`
            },
            {
                id: 11,
                name: "Гармоничные конфигурации аспектов.",
                description: `Любое везение – это опыт из прошлого накоплен. Конфигурации гармоничные, значит планеты встали в благоприятные отношения и проживать судьбоносные ситуации в этих сферах будет благоприятно.
Примеры: Моцарт, Наполеон, Е Рерих, Джони Дэп и др. всего 18 карт.`
            },
            {
                id: 12,
                name: "Синтез гороскопа. Практика.",
                description: `На данном уроке учимся все связывать во единое, совмещать исследования отдельных частей гороскопа. Целое состоит из отдельных тематик, данных, для них проводим анализ.
На уроке рассмотрено 25 натальных карт.`
            },
            {
                id: 13,
                name: "Вопросы астропсихологического исследования.",
                description: `Урок даст понятия, как каждого человека можно охарактеризовать сравнивая положение планет в домах и знаках. Знание: какую энергию тратят люди от рождения и на что он преимущественно тратят свою энергию.
Примеры: Марина Влади, Анджелина Джоли.`
            },
            {
                id: 14,
                name: "Алгоритм разбора карты. Практика.",
                description: `На уроке предложен подробный разбор Натальной карты. Пошаговое описание по слайдам, на примере Натальной карты Жака Ив Кусто.`
            },
        ],
    },
];

export default data;